import React from 'react';
import DOMPurify from 'dompurify';

interface SafeHTMLProps {
  html: string;
  className?: string;
  tag?: keyof JSX.IntrinsicElements;
}

const SafeHTML: React.FC<SafeHTMLProps> = ({ html, className, tag: Tag = 'div' }) => {
  const sanitizedHTML = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      'i',
      'b',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ul',
      'ol',
      'li',
      'blockquote',
      'a',
      'img',
      'span',
      'div',
      'table',
      'thead',
      'tbody',
      'tr',
      'td',
      'th',
      'blog',
      'small',
    ],
    ALLOWED_ATTR: [
      'href',
      'title',
      'alt',
      'src',
      'width',
      'height',
      'class',
      'id',
      'target',
      'rel',
      'style',
      'onError',
    ],
    ALLOWED_URI_REGEXP:
      /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
  });

  return <Tag className={className} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
};

export default SafeHTML;
